import { createContext } from "react";

export const MaturaReviewContext = createContext({ reviewAllowed: false, answersLocked: false,
  assessmentDisabled: false, interactive: false, mode: "training" });

export function reportMaturaProblem(task, answer) {
  const fields = answer && typeof answer === "object" ? Object.fromEntries(Object.entries(answer)
    .filter(([key]) => !["whiteboard", "reviewOpened", "reviewConfirmed", "selfScore", "automaticCheck", "courseWorkConfirmed"].includes(key))) : answer;
  const description = fields == null ? "" : typeof fields === "string" ? fields : JSON.stringify(fields);
  window.dispatchEvent(new CustomEvent("matematron:open-feedback", { detail: {
    message: `Problem ze sprawdzaniem zadania ${task.source?.taskNumber || ""} (${task.source?.basedOn || task.type || ""}).\nMoja odpowiedź: ${description.slice(0, 2000)}\nOpis błędu: `,
  } }));
}
